import { render } from "./theme24.vue?vue&type=template&id=64510126&scoped=true"
import script from "./theme24.vue?vue&type=script&lang=js"
export * from "./theme24.vue?vue&type=script&lang=js"

import "./theme24.vue?vue&type=style&index=0&id=64510126&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-64510126"

export default script